export default {
  issues: 'issue-recent-searches',
  merge_requests: 'merge-request-recent-searches',
  group_members: 'group-members-recent-searches',
  group_invited_members: 'group-invited-members-recent-searches',
  project_members: 'project-members-recent-searches',
  project_group_links: 'project-group-links-recent-searches',
};
